<section class="section">
    <div class="container-fluid">
        <div class="row d-flex justify-content-end">
            <div class="col-lg col-md-4 mt-2">
                <div class="form-floating">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        (change)="updateDetails($event,'name')" [(ngModel)]="productName">
                        <option selected disabled value="">Select Product Name</option>
                        <option value="all">All</option>
                        <option *ngFor="let name of this.productNameDetails">{{name}}</option>
                    </select>
                    <label for="floatingSelect">Product Name</label>
                </div>
            </div>


            <div class="col-lg col-md-4 mt-2">
                <div class="form-floating">
                    <select class="form-select" aria-label="Floating label select example"
                        (change)="updateDetails($event,'code')" [(ngModel)]="productCode">
                        <option selected disabled value="">Select Product Code</option>
                        <option value="all">All</option>
                        <option *ngFor="let code of this.productCodeDetails">{{code}}</option>
                    </select>
                    <label for="floatingSelect">Product Code</label>
                </div>
            </div>

            <div class="col-lg col-md-4 mt-2">
                <div class="form-floating">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        (change)="updateDetails($event,'date')" [(ngModel)]="productCreationDate">
                        <option selected disabled value="">Select Product Created Date</option>
                        <option value="all">All</option>
                        <option *ngFor="let date of this.productCreationDateDetails">{{date}}</option>
                    </select>
                    <label for="floatingSelect">Created Date</label>
                </div>
            </div>

            <div class="col-lg col-md-4 mt-2">
                <div class="form-floating">
                    <select class="form-select" id="floatingSelect" aria-label="Floating label select example"
                        (change)="updateDetails($event,'status')" [(ngModel)]="productStatus">
                        <option selected disabled value="">Select Availability Status</option>
                        <option value="all">All</option>
                        <option *ngFor="let status of this.productCurrentStatus">{{status}}</option>
                    </select>
                    <label for="floatingSelect">Availability Status</label>
                </div>
            </div>

            <div class="col-lg col-md-4 mt-2">
                <div class="form-floating">
                    <input type="search" class="form-control" placeholder="search" [(ngModel)]="searchText">
                    <label class="text-gray">Search</label>
                </div>
            </div>
        </div>

        <div class="row d-flex justify-content-end align-items-end">
            <div class="col-lg-2 col-md-4 mt-2 d-flex justify-content-end align-items-end">
                <button class="btn btn-danger mt-2" (click)="resetReviewFilter()">Clear Filters <img class="img-fluid"
                        alt="clear" src="assets/img/icons/clear-alt.png"></button>
            </div>
        </div>



        <div class="py-2"></div>


        <div class="container-fluid">
            <div class="table-style table-responsive table-bordered">
                <table class="table table-head-fixed text-nowrap text-center">
                    <thead>
                        <tr class="sticky-top">
                            <th>S.No</th>
                            <th>product Name</th>
                            <th>Product Code</th>
                            <th>Created Date / Time</th>
                            <th>Availability Status</th>
                            <th>Category</th>
                            <th>Edit</th>
                        </tr>
                    </thead>
                    <tbody class="text-center"
                        *ngIf="(productDetails | filter:searchText).length > 0; else noDataFound">
                        <tr *ngFor="let item of this.productDetails | filter: searchText; let i = index">
                            <td>{{i + 1}}</td>
                            <td>{{item.productName || "-"}}</td>
                            <td>{{item.productCode || "-"}}</td>
                            <td>{{item.createdAt | date : "dd-MM-yyy / hh:mm:ss aa"}}</td>
                            <td>
                                <select class="form-select" [(ngModel)]="item.availability"
                                    (change)="selectCurrentStatusUpdate(item)">
                                    <option disabled value="">Select a Availability</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </td>
                            <td>{{item.categoryDetails.categoryName || "-"}}</td>
                            <td><button class="btn btn-secondary border rounded-pill border-dark" (click)="EditAlert(item)"
                                > Edit <i class="fas fa-pen" tooltip="Click to edit the product"></i> </button></td>
                        </tr>
                    </tbody>
                    <ng-template #noDataFound>
                        <tr class="text-center ubuntu-bold h6 text-danger">
                            <td colspan="12">Data Not Found</td>
                        </tr>
                    </ng-template>
                </table>
            </div>
        </div>
    </div>
</section>